import Input from 'antd/lib/input'
require('antd/lib/input/style')
import styled from 'styled-components'
import { Colors } from '../../Themes'

const StyledInput = styled(Input)`
  && {
    &.ant-input-disabled {
      background: ${Colors.aliceBlue};
    }
  }
`

StyledInput.TextArea = Input.TextArea
StyledInput.Password = Input.Password

export default StyledInput
